import React from "react";
import styled from "styled-components";
import {
  Main,
  BroadcastStatusBar,
  RequestBookingBanner,
  PageHeroBackground,
} from "./components";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { fromTheCrowd } from "../assets/hero/pages";

const Hero = styled.div`
  width: 100%;
  margin-bottom: 25px;
  background: linear-gradient(to bottom left, #2e3f67, #0d1938);
  color: #ffffff;
  text-align: center;
  height: 125px;
  line-height: 125px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2.5em;
  overflow: hidden;

  ${PageHeroBackground(fromTheCrowd)}

  h1 {
    background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #aaaaaa);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0px;
    font-size: inherit;
  }

  @media (max-width: 500px) {
    font-size: 2em;
    height: 100px;
    line-height: 100px;
    margin-bottom: 10px;
  }
`;

const TextPane = styled.article`
  padding: 25px;

  a {
    color: #333;

    &[name] {
      text-decoration: none;
      display: block;

      &:not(:first-child) {
        margin-top: 50px;
      }
    }

    h2 {
      position: relative;
      &::before {
        position: absolute;
        left: -1.5em;
        padding-right: 1.5em;
        line-height: 1.6em;
        font-size: 0.7em;
        font-family: "Font Awesome 5 Pro";
        content: "\uf0c1";
        color: #bbb;
        opacity: 0;
        user-select: none;
        cursor: normal;
      }

      &:hover::before {
        opacity: 1;
      }
    }

    @media (prefers-color-scheme: dark) {
      color: #ddd;
    }
  }

  h2 {
    text-transform: uppercase;
    margin-top: 50px;

    &:first-child {
      margin-top: 0px;
    }

    @media (prefers-color-scheme: dark) {
      color: #fff;
    }
  }

  h3 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  h4 {
    margin-top: 0px;
    margin-bottom: 5px;
    font-style: italic;
    color: #555;

    & + p {
      margin-top: 5px;
      margin-bottom: 0px;
    }
  }

  i {
    margin-right: 5px;
    color: #555;

    @media (prefers-color-scheme: dark) {
      color: #fff;
    }
  }

  p,
  li {
    line-height: 1.5em;
  }

  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
`;

function Supporters() {
  return (
    <Main>
      <Helmet>
        <title>Sim Broadcasts | Broadcast Funding</title>
      </Helmet>
      <BroadcastStatusBar />
      <Hero>
        <h1>Broadcast Funding</h1>
      </Hero>
      <TextPane>
        <a name="broadcast-funding-tiers" href="#broadcast-funding-tiers">
          <h2>Broadcast Funding Tiers</h2>
        </a>
        <p>Our broadcast funding is divided into three tiers:</p>
        <ol>
          <li>
            <h3>Sponsored by Sim Broadcasts</h3>
            <p>
              Events organised by Sim Broadcasts, or provided free of charge to
              support the community or as a thank-you to event organisers.
            </p>
          </li>
          <li>
            <h3>Paid Contribution</h3>
            <p>
              Events where Sim Broadcasts are paid a contribution towards costs
              by the organiser or a third party.
            </p>
          </li>
          <li>
            <h3>Fully Funded</h3>
            <p>
              Events where broadcast costs are covered in full by the organiser
              or a third party.
            </p>
          </li>
        </ol>
        <p>
          The funding details of our broadcasts are advertised on each
          individual event on our <Link to="/calendar">calendar</Link>.
        </p>
        <a name="supporters-club" href="#supporters-club">
          <h2>Supporters Club</h2>
        </a>
        <p>
          Our Twitch revenue also contributes towards our broadcast funding.
        </p>
        <p>
          If you wish to support our channel directly, please consider joining
          our <Link to="supporters">supporters club</Link>.
        </p>
      </TextPane>
      <RequestBookingBanner />
    </Main>
  );
}

export default Supporters;
